import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { delay, map, Observable } from 'rxjs';

import { BaseHttpService } from '@shared/services-http/base-http.service';
import { IDownloadDriverTachoFilesBody, IGetDriverTachoFile, IGetFilesTachoBody, IGetVehicleTachoFile } from '@src/app/interfaces/api/files-ddd.interface';
import { WebResponse } from '@commons/models/remote.response/WebResponse';
import { NewDataStoreService } from '@shared/services/new-data-store.service';
import { IPagination } from '@src/app/interfaces/api/pagination.interface';

@Injectable({
  providedIn: 'root'
})
export class FilesDddService extends BaseHttpService {

  constructor(
    private httpClient: HttpClient,
    private newDataStoreService: NewDataStoreService,
  ) {
    super();
  }

  public GetDriverTachoFileList(data: IGetFilesTachoBody): Observable<IPagination<IGetDriverTachoFile>> {
    return this.httpClient.post<WebResponse>(this.getUrl('/GetDriverTachoFileList'), data)
      .pipe(
        delay(500),
        map(res => ({ ...res.Result, Result: res.Result.Result.map((el: IGetDriverTachoFile) => ({ ...el, Driver: this.newDataStoreService.getDriverById(el.DriverId) })) })),
      );
  }

  public GetVehicleTachoFileList(data: IGetFilesTachoBody): Observable<IPagination<IGetVehicleTachoFile>> {
    return this.httpClient.post<WebResponse>(this.getUrl('/GetVehicleTachoFileList'), data)
      .pipe(
        delay(500),
        map(res => ({ ...res.Result, Result: res.Result.Result.map((el: IGetVehicleTachoFile) => ({ ...el, Vehicle: this.newDataStoreService.getVehicleById(el.VehicleId) })) })),
      );
  }

  public DownloadDriverTachoFiles(data: IDownloadDriverTachoFilesBody): Observable<any> {
    return this.httpClient.post(this.getUrl('/DownloadDriverTachoFiles'), data, {
      observe: 'response',
      responseType: 'blob'
    });
  }

  public DownloadVehicleTachoFiles(data: IDownloadDriverTachoFilesBody): Observable<any> {
    return this.httpClient.post(this.getUrl('/DownloadVehicleTachoFiles'), data, {
      observe: 'response',
      responseType: 'blob'
    });
  }

}
